import { Box, Link, SxProps, useMediaQuery } from "@mui/material";

import React, { FC } from "react";
import { Colors } from "@src/gatsby-theme-material-ui-top-layout/colors-twentyfive";
import useHash from "@src/hooks/hash";
import { motion } from "motion/react";
import { useTheme } from "@mui/material/styles";

interface Props {
  navItem: any;
}

const NavItemRegular: FC<Props> = ({ navItem }) => {
  const hash = useHash();
  const theme = useTheme();
  const isLarge = useMediaQuery(theme.breakpoints.up("lg"));
  const isMedium = useMediaQuery(theme.breakpoints.up("md"));

  const baseStyles: SxProps = {
    display: "flex",
    position: "relative",
    borderRadius: "100px",
    border: `solid 1px ${Colors.AiOutline}`,
    fontSize: {
      xs: "12px",
      lg: "15px",
    },
    fontWeight: 400,
    paddingX: "20px",
    minHeight: {
      xs: "30px",
      lg: "40px",
    },
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    textDecoration: "none",
    width: {
      xs: "300px",
      lg: "auto",
    },
  };

  const defaultStyles: SxProps = {
    ...baseStyles,
    color: Colors.PrimaryContrast,
    "&:hover": {
      cursor: "pointer",
      color: Colors.PrimaryContrast,
    },
    "&:visited": {
      color: Colors.PrimaryContrast,
    },
  };

  const previewStyles: SxProps = {
    ...defaultStyles,
    opacity: 0.5,
  };

  const selectedStyles: SxProps = {
    ...baseStyles,
    color: "#0F0D13",
    fontWeight: 600,
    backgroundImage: "linear-gradient(90deg, #FFCDAF 12.35%, #8C48EB 88.07%)",
    "&:hover": {
      cursor: "pointer",
      color: "#0F0D13",
    },
    "&:visited": {
      color: "#0F0D13",
    },
  };

  return (
    <Link
      sx={
        hash === navItem.data.categoryId
          ? selectedStyles
          : navItem?.data?.isPreview === true
            ? previewStyles
            : defaultStyles
      }
      href={`#${navItem.data.categoryId}`}
      data-cid={navItem.data.categoryId}
    >
      {navItem.data.name}
      {!isMedium && navItem?.data?.childrenCount > 0 && (
        <>&nbsp;(+{navItem?.data?.childrenCount})</>
      )}

      <Box
        sx={{
          position: "absolute",
          display: {
            md:
              hash !== navItem.data.categoryId &&
              navItem?.data?.childrenCount > 0 &&
              !navItem.data.selectedParent
                ? "flex"
                : "none",
            xs: "none",
          },
          width: "20px",
          height: "1px",
          borderBottom: `solid 1px ${Colors.AiOutline}`,
          borderRadius: "100px",
          right: "-20px",
          justifyContent: "center",
          alignItems: "center",
        }}
      />

      <Box
        component={motion.div}
        sx={{
          position: "absolute",
          display: {
            xs: "none",
            md: "flex",
          },
          width: {
            xs: "30px",
            lg: "40px",
          },
          height: {
            xs: "30px",
            lg: "40px",
          },
          border: `solid 1px ${Colors.AiOutline}`,
          borderRadius: "100px",
          right: {
            xs: "-50px",
            lg: "-60px",
          },
          justifyContent: "center",
          alignItems: "center",
          pointerEvents:
            hash !== navItem.data.categoryId && navItem?.data?.childrenCount > 0
              ? "all"
              : "none",
        }}
        initial={{
          opacity: 0,
        }}
        animate={{
          opacity:
            hash !== navItem.data.categoryId &&
            navItem?.data?.childrenCount > 0 &&
            !navItem.data.selectedParent
              ? 1
              : 0,
        }}
        transition={{
          duration: 0.3,
        }}
      >
        <span>+{navItem?.data?.childrenCount}</span>
      </Box>
    </Link>
  );
};

export default NavItemRegular;
